import { Routes, Route } from "react-router-dom";
import Reservation from "./components/Clientpanel/Reservation/Reservation";
import { AuthProvider } from "./contexts/AuthContext";
import Embed from "./components/Clientpanel/Reservation/Embed";
import EmbedWidget from "./components/Clientpanel/Reservation/EmbedWidget";

const ReservationRoutes = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route index element={<Reservation />} />
        <Route path="dashboard" element={<Reservation />} />
        <Route path="conversations" element={<Reservation />} />
        <Route path="embed-docs" element={<Reservation />} />
        <Route path="settings" element={<Reservation />} />
        <Route path="embed/widget" element={<EmbedWidget />} />
        <Route path="embed" element={<Embed />} />        
      </Routes>
    </AuthProvider>
  );
};

export default ReservationRoutes;